import axios from 'axios';

export const API = process.env.REACT_APP_API_URL || 'https://api.pixlybooth.com';
export const ax = () => axios.create({ withCredentials: true });

export const card = {
  background: 'linear-gradient(135deg,#101428 0%,#0D0F20 100%)',
  borderRadius: 14, padding: 24,
  border: '1px solid rgba(255,255,255,0.07)', marginBottom: 20,
};

export const btn = (color = '#E34364', outline = false) => ({
  background: outline ? 'transparent' : color, color: '#fff',
  border: `1px solid ${color}`, borderRadius: 8, padding: '8px 16px',
  fontSize: 12, fontWeight: 700, cursor: 'pointer',
});

export const inp = (err) => ({
  width: '100%', background: 'rgba(255,255,255,0.05)',
  border: `1px solid ${err ? '#E34364' : 'rgba(255,255,255,0.1)'}`,
  borderRadius: 10, padding: '10px 12px', color: '#fff', fontSize: 13,
  outline: 'none', boxSizing: 'border-box',
});

// Reusable image upload zone — uses a <label> so clicking always works
export function ImageUploadZone({ label, file, onChange }) {
  return (
    <label
      style={{
        display: 'block', border: '2px dashed rgba(159,92,255,0.4)',
        borderRadius: 12, padding: 20, textAlign: 'center', marginBottom: 16,
        background: 'rgba(159,92,255,0.05)', cursor: 'pointer',
      }}
    >
      <p style={{ margin: '0 0 6px', color: '#fff', fontSize: 13, fontWeight: 600 }}>
        🖼️ {label || 'Upload Image'}
      </p>
      <span style={{ color: file ? '#27C85A' : '#9F5CFF', fontSize: 13 }}>
        {file ? file.name : 'Click to select an image'}
      </span>
      <input
        type="file"
        accept="image/*"
        onChange={onChange}
        style={{ display: 'none' }}
      />
    </label>
  );
}
